import NewLineToBr from '@global/NewLineToBr'
import ReadMoreReadLess from '@global/ReadMoreReadLess'
import * as S from './PropertyInfo.styled'

const PropertyInfo = ({ heading, description }) => {
  return (
    <S.PropertyInfo>
      <S.PropertyInfoHeading>{heading}</S.PropertyInfoHeading>
      {description && (
        <ReadMoreReadLess
          content={<NewLineToBr value={description} />}
          isReactComponent
        />
      )}
    </S.PropertyInfo>
  )
}

export default PropertyInfo
